// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by Download.js which is called by home component.
*/

.download-button {
    background-color: #0C3135;
    height: 2.0rem;
    width: 3%;
    color: white;
    padding: 8px 16px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s ease;
    margin: 0px 0;  
    margin-top: 0px;
    float: right;   
    margin-right: 1px; 
    font-size: 0.8rem;
    padding: 1%;
    border-radius: 8px;
}

.download-button:hover {
    background-color: #2a5a5a;
}

.download-button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

.download-button:active {
    transform: translateY(1px);
}

.table-container {
    clear: both;
}

@media screen and (max-width: 321px) {
    .download-button{
        width: 10vw !important;
        margin-left: 0% !important;
    }
}

@media (min-width: 321px) and (max-width: 376px)  {
    .download-button{
        width: 10vw !important;
        margin-left: 0% !important;
    }
}

@media (min-width: 376px) and (max-width: 426px) {
    .download-button{
        width: 10vw !important;
        margin-left: 0% !important;
    }
}

@media (min-width: 426px) and (max-width: 769px) {
    .download-button{
        width: 5vw !important;
        margin-left: 0% !important;
    }
}

@media (min-width: 769px) and (max-width: 1025px) {
    .download-button{
        width: 3vw !important;
        margin-left: 0% !important;
    }
}

@media (min-width: 1921px){
    .download-button{
        width: 1.5vw !important;
        margin-left: 0% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Download/Download.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;IACI,yBAAyB;IACzB,cAAc;IACd,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,0BAA0B;IAC9B;AACJ","sourcesContent":["/*\nThis style file is imported by Download.js which is called by home component.\n*/\n\n.download-button {\n    background-color: #0C3135;\n    height: 2.0rem;\n    width: 3%;\n    color: white;\n    padding: 8px 16px;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s ease;\n    margin: 0px 0;  \n    margin-top: 0px;\n    float: right;   \n    margin-right: 1px; \n    font-size: 0.8rem;\n    padding: 1%;\n    border-radius: 8px;\n}\n\n.download-button:hover {\n    background-color: #2a5a5a;\n}\n\n.download-button:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n}\n\n.download-button:active {\n    transform: translateY(1px);\n}\n\n.table-container {\n    clear: both;\n}\n\n@media screen and (max-width: 321px) {\n    .download-button{\n        width: 10vw !important;\n        margin-left: 0% !important;\n    }\n}\n\n@media (min-width: 321px) and (max-width: 376px)  {\n    .download-button{\n        width: 10vw !important;\n        margin-left: 0% !important;\n    }\n}\n\n@media (min-width: 376px) and (max-width: 426px) {\n    .download-button{\n        width: 10vw !important;\n        margin-left: 0% !important;\n    }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n    .download-button{\n        width: 5vw !important;\n        margin-left: 0% !important;\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1025px) {\n    .download-button{\n        width: 3vw !important;\n        margin-left: 0% !important;\n    }\n}\n\n@media (min-width: 1921px){\n    .download-button{\n        width: 1.5vw !important;\n        margin-left: 0% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
